import React from 'react'
import Navbar from './navbar'

const Organisation = () => {
  return (
    <div>  
        <Navbar/> 
        hi organisation
    </div>
  )
}

export default Organisation
